import { App } from "../data/statics/enums";
import { Hosts } from "./types";

export const hosts: Hosts = {
  environment: "production",
  frontend: {
    [App.Core]: "https://auth.songtradr.com",
    [App.Account]: "https://account.auth.songtradr.com",
    [App.Admin]: "https://admin.auth.songtradr.com",
  },
  assets: "https://assets.rights.massivemusic.com",
  backend: {
    [App.Core]: "https://api.auth.songtradr.com",
    [App.Account]: "https://api.account.auth.songtradr.com",
    [App.Admin]: "https://api.admin.auth.songtradr.com",
  },
  cookies: {
    sso: { domain: "auth.songtradr.com", path: "/api/v1" },
    sso_r: { domain: "auth.songtradr.com", path: "/api/v1/auth/r" },
    auth_context: { domain: ".auth.songtradr.com" },
  },
  // Allow wildcards for client-specific subdomains (e.g., redbull.auth.songtradr.com)
  cors: [/^https:\/\/(?:[a-zA-Z0-9_-]+\.)?auth\.songtradr\.com(?:\/.*)?$/],
} as const;
